import { type HTMLAttributes, type ReactNode } from 'react'

interface MarqueeProps extends HTMLAttributes<HTMLDivElement> {
  reverse?: boolean
  pauseOnHover?: boolean
  vertical?: boolean
  repeat?: number
  children: ReactNode
  duration?: number
  gap?: string
}

export function Marquee({
  className = '',
  reverse = false,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  duration = 40,
  gap = '2.5rem',
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={`group flex overflow-hidden [--duration:${duration}s] ${
        vertical ? 'flex-col' : 'flex-row'
      } ${className}`}
      style={{
        // @ts-expect-error CSS var
        '--duration': `${duration}s`,
        '--gap': gap,
        gap,
      }}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={`flex shrink-0 justify-around [gap:var(--gap)] ${
              vertical
                ? 'animate-marquee-vertical flex-col'
                : 'animate-marquee-premium flex-row'
            } ${pauseOnHover ? 'group-hover:[animation-play-state:paused]' : ''} ${
              reverse ? '[animation-direction:reverse]' : ''
            }`}
          >
            {children}
          </div>
        ))}
    </div>
  )
}
